import { apiFetch, withQuery } from '@/app/apiClient';

import {
  ATTESTATIONS_ENDPOINTS,
  type AttestationRow,
  type AttestationsApi,
  type AttestationsSummary,
} from './api';

/** Real HTTP client for the Attestations screen. */
export function createFetchAttestationsApi(): AttestationsApi {
  return {
    getSummary: async () => apiFetch<AttestationsSummary>(ATTESTATIONS_ENDPOINTS.summary),
    listAttestations: async (query) =>
      apiFetch<AttestationRow[]>(
        withQuery(ATTESTATIONS_ENDPOINTS.list, { status: query.status }),
      ),
    verify: async (id) =>
      apiFetch<{ verified: boolean; verifiedAt: string }>(
        ATTESTATIONS_ENDPOINTS.verify(encodeURIComponent(id as unknown as string)),
        { method: 'POST' },
      ),
    downloadArtifact: async (id) =>
      apiFetch<unknown>(
        // The server projects the full signed artifact onto the list
        // endpoint today; we fetch the list and filter client-side so we
        // don't spin up a dedicated byId projection until the Evidence
        // export CLI lands. (Still real fetch — the endpoint is hit.)
        ATTESTATIONS_ENDPOINTS.list,
      ).then((rows) => {
        const list = rows as AttestationRow[];
        const target = list.find((r) => (r.attestationId as string) === (id as string));
        return target ?? null;
      }),
  };
}
